/*
 * @Author: cn1994
 * @Date: 2025-04-15 11:44:04
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-15 13:30:30
 * @Description: file content
 */
import WebTracker from '@aliyun-sls/web-track-browser';

const slsTracker = new WebTracker({
  host: 'cn-hangzhou.log.aliyuncs.com', // 阿里云SLS项目入口
  project: 'tyty',                  // 项目名称
  logstore: 'tyty_oss_web',                // Logstore名称
  source: '业务管理后台',
  time: 0,                                      // 上报间隔(秒)
});

// 全局错误处理
const initErrorTracking = () => {
  // 监听全局错误
  window.addEventListener('error', (event) => {
    slsTracker.send({
      errorType: 'window_error',
      message: event.message,
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
      stack: event.error?.stack,
    });
  });

  // 监听未处理的Promise rejection
  window.addEventListener('unhandledrejection', (event) => {
    slsTracker.send({
      errorType: 'unhandled_rejection',
      reason: event.reason?.toString(),
      stack: event.reason?.stack,
    });
  });
};

export { slsTracker, initErrorTracking };